import React, { Component } from "react";
import { cloneDeep } from "lodash";
import {Col, Form, Input, InputNumber, message, Modal, Row, Select} from "antd";
import {
  BankOutlined,
  BarcodeOutlined,
  FundViewOutlined,
  UserOutlined,
  DollarCircleOutlined,
} from "@ant-design/icons";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";
import API from "../scripts/api";
import { Upload } from 'antd';
import {PlusOutlined, ProjectOutlined} from '@ant-design/icons';
import {Constants} from "../scripts/settings";
import {SearchFormat} from "../scripts/helpers";
import {isArray} from "leaflet/src/core/Util";
class PrintBarcodeForm extends Component {
  constructor() {
    super();

    this.state = {

      products: [],
      selected: [],

      imageGallery: [],
      imageGalleryData: [],
      packages: [],
      shelves: [],
      identifiers: [],
      rows: [],
      editMode:false,
      selectedProductId:"",
      selectedProduct:{}

    };

    this.formRef = React.createRef();
    this.inputRef = React.createRef();
  }

  handleChange = () => {
    this.formRef.current.setFieldsValue({ subCategory: undefined });
  };

  handleSubmit = () => {
    this.formRef.current.validateFields().then((values) => {
      const formData = new FormData();

      console.log("handleSubmit", this.state.selectedProductId)
      formData.append("product_id", this.state.selectedProductId);
      // formData.append("product_id", values.search);
      if((values.package_count) && (values.package_count != undefined)){
        formData.append("package_count", values.package_count);
      }
      if((values.count) && (values.count != undefined)){
        formData.append("count", values.count);
      }
      if((values.size_id) && (values.size_id != undefined)){
        formData.append("size", values.size_id);
      }
      if((values.shelf_id) && (values.shelf_id != undefined)){
        formData.append("shelf_id", values.shelf_id);
      }
      if((values.row_id) && (values.row_id != undefined)){
        formData.append("row_id", values.row_id);
      }
      if((values.identifier_id) && (values.identifier_id != undefined)){
        formData.append("identifier_id", values.identifier_id);
      }
      this.props.onSubmit(formData);
    });
  };

  handleWillUnmount = () => {
    console.log("handleWillUnmount")
    this.setState({selectedProductId: "", selectedProduct:{}})

    this.formRef.current.resetFields();
  };

  handleDidMount = async (data = {}) => {
    const cloneData = await cloneDeep(data);
    console.log(data)
    // cloneData.category = cloneData.category ? cloneData.category.id : undefined;
    // cloneData.subCategory = cloneData.sub_category
    //   ? cloneData.sub_category.id
    //   : undefined;
    this.setState({ editMode: !!cloneData.id });

    if (!!cloneData.id){
      await this.formRef.current.setFieldsValue(cloneData);

    }
    await this.getPackages()
    await this.getShelves()
    await this.getRows()
    await this.getIdentifiers()



    // document.querySelector('.ant-select').click()
    // document.querySelector('.ant-select-xl').click()
    // document.querySelector('.ant-select-selector').click()
    // document.querySelector('.ant-select-selection-search').click()
    // document.querySelector('input').click()
    // this.inputRef.current.focus();



  };


  getPackages = () => {
    this.setState({ submitting: true });

    API.productPackage
        .list()
        .then((result) => {
          this.setState({ submitting: false, packages:result.data });
        })
        .catch(() => {
          this.setState({ submitting: false });
        });
  };
  getShelves = () => {
    this.setState({ submitting: true });

    API.shelf
        .list({total: true})
        .then((result) => {
          this.setState({ submitting: false, shelves:result.data });
        })
        .catch(() => {
          this.setState({ submitting: false });
        });
  };
  getRows = () => {
    this.setState({ submitting: true });

    API.productRow
        .list({total: true})
        .then((result) => {
          this.setState({ submitting: false, rows:result.data });
        })
        .catch(() => {
          this.setState({ submitting: false });
        });
  };
  getIdentifiers = () => {
    this.setState({ submitting: true });

    API.productIdentifier
        .list({total: true})
        .then((result) => {
          this.setState({ submitting: false, identifiers:result.data });
        })
        .catch(() => {
          this.setState({ submitting: false });
        });
  };
  handleCount = (value, record) => {
    console.log("handleCount")
    const products = [...this.state.products];
    const index = products.findIndex((o) => o.id === record.id);
    const product = products[index];
    product.count = value;
    products.splice(index, 1, product);
    this.setState({
      formData: { ...this.state, ...{ products: products } },
    });
  };

  handleSelect = (value, clear) => {
    console.log("handleSelect", value)
    if (value) {
      this.setState({selectedProductId: value})

      const { products, selected } = this.state;
      const product = selected.find(o => o.id === value);

      if (product) {
        console.log("handleSelect product 1", product)
        this.setState({selectedProduct: product})
        this.handleCount(product.count + 1, product);
      } else {
        const product = products.find(o => o.id === value);
        console.log("handleSelect product 2 ", product)
        this.setState({selectedProduct: product})
        this.setState({ selected: [...selected, product] });
      }


      if (clear) {
        this.setState({ products: [] });
        this.formRef.current.resetFields();
        this.inputRef.current.focus();
        console.log("clear 3")
      }
    } else {
      console.log("clear 2")
      this.setState({ products: [] });
    }
  }

  handleSearch = (value) => {

    if (value){
      // this.handleSearchTimeOut(value)
      if(this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        console.log("into timerrrrrrrrr", value)
        //search function
        this.handleSearchTimeOut(value)
      }, 300);
    }


  };
  handleSearchTimeOut = (value) => {
    console.log("handleSearch", value)

    this.inputRef.current.focus();
    if (value) {
      this.setState({selectedProductId: "", selectedProduct:{}})

      API.product.list({ q: SearchFormat(value) }).then((result) => {
        if (result.data && result.data.length) {
          const products = result.data.map(o => {
            this.inputRef.current.focus();

            return {
              id: o.id,
              name: o.name,
              image: o.gallery && o.gallery.length ? o.gallery[0].image : null,
              code: o.code,
              priceOne: parseInt(o.priceOne),
              priceTwo: parseInt(o.priceTwo),
              priceThree: parseInt(o.priceThree),
              offer: parseInt(o.priceOne),
              count: 1,
              value: value
            }
          });

          this.setState({ products: products });

          if (products.length === 1) {
            setTimeout(() => {
              console.log("products.length is 1", products[0])
              this.handleSelect(products[0].id);
            }, 0);
          }
        } else {
          console.log("clear 1")
          this.setState({selectedProductId: "", selectedProduct:{}})
          this.setState({ products: [] });
        }
      });
    }
  }
  handleFilter = (input, option) => {
    console.log("filter")
    const value = SearchFormat(input);
    const split = value.split(' ');
    let valid = option.code.indexOf(value) >= 0;

    split.forEach(val => {
      valid = valid || option.name.indexOf(val) >= 0;
    });
    console.log("valid", valid)
    return valid;
  }
  render() {
    const { onCancel, subCats, submitting, visible } = this.props;
    const {imageGallery, products, packages, editMode, selectedProductId, selectedProduct,
    shelves, rows, identifiers
    } = this.state;


    return (
      <Modal
          title={editMode ? Resources.edit : Resources.add}
        visible={visible}
        onOk={this.handleSubmit}
        onCancel={onCancel}
        okText={Resources.confirm}
        cancelText={Resources.cancel}
        okButtonProps={{ loading: submitting }}
        cancelButtonProps={{ disabled: submitting }}
        width={1000}
      >
        <Form ref={this.formRef} layout="vertical">
          <Row gutter={24}>

            {!editMode && selectedProduct &&
            <Col xs={24} md={24}>
              <span>{selectedProduct.name}</span>
            </Col>
            }

            { !editMode &&
              <Col xs={24}>
                <Form.Item name="search" initialValue={selectedProductId}>
                  <Select

                      allowClear
                      // menuIsOpen
                      autoFocus
                      filterOption={(input, option) => this.handleFilter(input, option)}
                      onSearch={this.handleSearch}
                      onChange={val => this.handleSelect(val, false)}
                      placeholder={Resources.search}
                      ref={this.inputRef}
                      className="ant-select-xl"
                      showSearch
                      // isSearchable={false}
                      // defaultOpen={true}
                  >
                    {products.map(o => <Select.Option key={o.id} value={o.id} name={o.name} code={o.code + o.value}>{o.name}</Select.Option>)}
                  </Select>
                </Form.Item>
              </Col>


            }

            <Col xs={24} md={8}>
              <Form.Item
                name="package_count"
                label={`${Resources.packing}`}
              >
                <Select
                  filterOption
                  // onChange={this.handleChange}
                  placeholder={Resources.choose}
                  optionFilterProp="name"
                  style={{ display: "block" }}
                  showSearch
                >
                  { packages && isArray(packages) &&
                  packages.map(o => <Select.Option key={o.id} value={o.count} name={o.title}>{o.title}</Select.Option>)


                  }

                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                  name="count"
                  label={Resources.count}
              >
                <Input
                    type="number"
                    dir="ltr"

                />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                name="size_id"
                label={`${Resources.size}`}
              >
                <Select
                  filterOption
                  placeholder={Resources.choose}
                  optionFilterProp="name"
                  style={{ display: "block" }}
                  showSearch
                >
                    <Select.Option value="little" >کوچک</Select.Option>
                    <Select.Option  value="middle" >متوسط</Select.Option>
                    <Select.Option  value="large" >بزرگ</Select.Option>
                </Select>
              </Form.Item>
            </Col>


            <Col xs={24} md={8}>
              <Form.Item
                  name="shelf_id"
                  label={`${Resources.shelf}`}
              >
                <Select
                    filterOption
                    // onChange={this.handleChange}
                    placeholder={Resources.choose}
                    optionFilterProp="name"
                    style={{ display: "block" }}
                    showSearch
                >
                  { shelves && isArray(shelves) &&
                  shelves.map(o => <Select.Option key={o.id} value={o.id} >{o.title}</Select.Option>)
                  }

                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                  name="row_id"
                  label={`${Resources.row}`}
              >
                <Select
                    filterOption
                    // onChange={this.handleChange}
                    placeholder={Resources.choose}
                    optionFilterProp="name"
                    style={{ display: "block" }}
                    showSearch
                >
                  { rows && isArray(rows) &&
                  rows.map(o => <Select.Option key={o.id} value={o.id} >{o.title}</Select.Option>)


                  }

                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item
                  name="identifier_id"
                  label={`${Resources.identifier}`}
              >
                <Select
                    filterOption
                    // onChange={this.handleChange}
                    placeholder={Resources.choose}
                    optionFilterProp="name"
                    style={{ display: "block" }}
                    showSearch
                >
                  { identifiers && isArray(identifiers) &&
                  identifiers.map(o => <Select.Option key={o.id} value={o.id}>{o.title}</Select.Option>)


                  }

                </Select>
              </Form.Item>
            </Col>

          </Row>
        </Form>
      </Modal>
    );
  }
}

export default PrintBarcodeForm;
